// @flow
// /* eslint-disable */
import {
  call, put,
} from 'redux-saga/effects';

import { logout } from '../actions';
import actionTypes from '../actionTypes';

export default function* checkAuth(): any {
  const jwt = localStorage.getItem('accessToken');
  const email = localStorage.getItem('email');
  if (!jwt || !email) return yield call(logout);
  const payload = {
    isAuthenticated: true,
    email,
    token: jwt,
  };
  try {
    yield put({ type: `${actionTypes.CHECK_AUTH}_SUCCESS`, payload });
  } catch (e) {
    if (e.message === 'Unauthorized') {
      // yield put(showModalSignOut(true));
    }
    return yield call(logout);
  }
  return null;
}
